import useGamePassUnlock from "./useGamePassUnlock";
export default useGamePassUnlock;
export { useGamePassUnlock };
